<template>
    <b-modal
        id="custom-timeline-banner"
        :title="$t('profile.custom_banner')"
        modal-class="apprentice-default-modal"
        ok-only
        :ok-title="$t('common.close')">
        <div class="custom-timeline-banner-upload">
            <div class="banner-uplaod-info text-muted">
                {{ $t('profile.upload_your_own_banner_here_in_the_jpg_file_type') }}
            </div>

            <div
                class="banner-preview"
                v-if="bannerIn">
                <p class="current-custom-banner">{{ $t('profile.example_custom_banner') }}</p>
                <b-img
                    v-if="bannerIn.file.image"
                    :src="bannerIn.file.image.thumb_path"></b-img>
            </div>

            <div class="banner-upload-actions">
                <b-button
                    class="btn-upload btn-upload-banner"
                    variant="primary"
                    @click="$refs.bannerUpload.$el.childNodes[0].click()">
                    {{ $t('profile.upload_banner') }}
                </b-button>
                <b-button
                    class="btn-restore btn-restore-banner"
                    v-if="bannerIn"
                    variant="danger"
                    @click="restoreBanner">
                    {{ $t('profile.restore_banner') }}
                </b-button>
            </div>
            <b-form-file
                id="upload-custom-timeline-banner"
                v-model="file"
                v-show="false"
                accept="image/jpeg"
                :placeholder="'Banner'"
                @change="onFileChange"
                ref="bannerUpload">
            </b-form-file>
        </div>
    </b-modal>
</template>

<script>
export default {
    name: 'design-2021-profile-timeline-custom-banner-modal-component',
    props: {
        bannerIn: Object,
    },

    data() {
        return {
            banner: '',
            file: null,
        };
    },

    methods: {
        onFileChange(evt) {
            this.saveBanner(evt.target.files[0]);
        },

        saveBanner(file) {
            if (file === null) {
                return;
            }

            const data = new FormData();
            const options = {
                headers: { 'Content-Type': 'multipart/form-data' },
            };

            data.append('file', file);

            this.alert.saving();
            axios.post(this.routes.profileBannerUpload(), data, options).then(
                (response) => {
                    this.alert.success();
                    window.location.href = `${this.routes.profile()}`;
                },
                (error) => {
                    if (error.response.data.errors && error.response.data.errors.banner) {
                        this.alert.ajaxError(
                            this.$t('profile.upload_failed'),
                            this.$t('profile.make_sure_the_banner_is_a_jpeg_file'),
                            false,
                        );
                    } else {
                        this.alert.ajaxError(error);
                    }
                },
            );
        },

        restoreBanner() {
            this.alert
                .confirm(
                    this.$t('profile.restore_banner'),
                    this.$t('profile.are_you_sure_you_want_to_restore_the_banner'),
                    this.$t('common.yes_recover'),
                )
                .then((confirm) => {
                    if (!confirm) {
                        return;
                    }

                    this.alert.saving();
                    axios.delete(this.routes.profileBannerRemove(this.bannerIn.id)).then(
                        (response) => {
                            this.alert.success();
                            window.location.href = `${this.routes.profile()}`;
                        },
                        (error) => {
                            this.alert.ajaxError(error);
                        },
                    );
                });
        },
    },
};
</script>

<style scoped lang="scss">
.current-custom-banner {
    margin-top: map-get($grid-gutter-spacing, 'twenty-one');
    font-weight: $font-weight-bold;
}

.banner-upload-actions {
    display: flex;
    align-items: center;
    margin-top: $grid-gutter-width;

    .btn {
        &:not(:last-child) {
            margin-right: map-get($grid-gutter-spacing, 'fifteen');
        }
    }
}
</style>
